import React from "react";
import styled, { useTheme } from "styled-components";

const Icon = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.lightGrey,
  borderRadius: "3px",
  color: theme.colors.darkGrey,
  fontSize: "12px",
  fontWeight: theme.fontWeights.bold,
  marginTop: "6px",
  paddingLeft: "12px",
  paddingRight: "12px",
  paddingTop: "4px",
}));

const Text = styled.span`
  position: relative;
  top: -7px;
`;

export default function ReadonlyIcon() {
  const theme = useTheme();

  return (
    <Icon>
      <svg
        height="24"
        style={{
          display: "inline",
          fill: theme.colors.darkGrey,
          left: "-3px",
          padding: "0px",
          position: "relative",
        }}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
      </svg>{" "}
      <Text>READ-ONLY</Text>
    </Icon>
  );
}
